import { Injectable, Injector } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { DepartmentResource } from '../models/resource/department.resource';
import { Department } from '../models/ui/department.model';
import { DepartmentResourceToDepartmentMapper } from '../models/mappers/department-resource-to-department.mapper';

const departmentMapper = new DepartmentResourceToDepartmentMapper();

@Injectable({ providedIn: 'root' })
export class DepartmentSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public getDepartments(): Observable<Department[]> {
		return this.makeHttpRequest<DepartmentResource[]>('get', `api2/departments`).pipe(
			map((response) => {
				return departmentMapper.mapCollection(response);
			})
		);
	}
}
